module.exports = __webpack_public_path__ + "media/newstyle/images/icon-have-ea3771fc1f107a4f86e61b6e391d5adf.svg";